import {css, StyleSheet} from 'aphrodite';
import React, {useCallback, useState} from 'react';

import {sendDeepResearchMessage} from 'llm/deep-research/DeepResearchDAO';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

import {DeepResearchChatInput, useDeepResearchChatInputControls} from './DeepResearchChatInput';

export function DeepResearchChat(): JSX.Element {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [chatId, _setChatId] = useState<string | undefined>(undefined);
  const {message, setMessage} = useDeepResearchChatInputControls();

  const handleSubmitMessage = useCallback(async () => {
    if (!message.trim() || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      await sendDeepResearchMessage(chatId, message);
      setMessage('');
    } finally {
      setIsSubmitting(false);
    }
  }, [chatId, message, isSubmitting, setIsSubmitting, setMessage]);

  return (
    <div className={css(styles.chatContainer)}>
      <div>
        <InlineBanner
          bannerType={InlineBannerType.BETA}
          hideIcon={true}
          text={<span>This is a Benchling Intelligence Feature.</span>}
          supportingInfo={<span>This feature is powered by AI, and may make mistakes.</span>}
          action={{actionType: InlineBannerActionType.ACCORDION}}
        />
      </div>
      <div />
      <DeepResearchChatInput
        message={message}
        setMessage={setMessage}
        onSubmit={handleSubmitMessage}
        inputDisabled={isSubmitting}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
  },
});
